/**
 * Block is used on
 *
 * @returns {{careHomesMenuOpen: boolean, manorcourtHomecareMenuOpen: boolean, checkIfMobileMenuNeedsClosing(): void, mobileMenuOpen: boolean}}
 */
export default () => ({
    careHomesMenuOpen: false,
    manorcourtHomecareMenuOpen: false,
    mobileMenuOpen: false,

    closeMenu() {
        this.careHomesMenuOpen=false;
        this.manorcourtHomecareMenuOpen=false;
        this.mobileMenuOpen= false;
    },

    checkIfMobileMenuNeedsClosing() {
        if (this.mobileMenuOpen) {
            this.mobileMenuOpen = window.innerWidth < 1024
        }
    }
})